import * as Pages from 'pages';
import { CONSTANTS } from 'utils';
import { CssBaseline } from '@mui/material';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { Layout } from 'components';
import { Home } from 'pages/Home/Home';

const getElement = (child: React.ReactNode): React.ReactNode => {
  return (
    <Layout>
      {child}
    </Layout>
  );
};

const router = createBrowserRouter([
  {
    path: CONSTANTS.PAGES.HOME,
    element: getElement(<Home />)
  },
  {
    path: CONSTANTS.PAGES.ABOUT_US,
    element: getElement(<Pages.AboutUs />)
  },
  {
    path: CONSTANTS.PAGES.BLOG,
    element: getElement(<Home />)
  },
  {
    path: CONSTANTS.PAGES.CONTACT,
    element: getElement(<Pages.Contact />)
  },
  {
    path: CONSTANTS.PAGES.PRIVACY_POLICY,
    element: getElement(<Pages.PrivacyPolicy />)
  },
  // {
  //   path: CONSTANTS.PAGES.DELETE_ACCOUNT,
  //   element: <Home />
  // },
  // {
  //   path: CONSTANTS.PAGES.LOGIN,
  //   element: <Pages.Login />
  // },
  // {
  //   path: CONSTANTS.PAGES.REGISTER,
  //   element: <Pages.Register />
  // },
  // {
  //   path: `${CONSTANTS.PAGES.VERIFY_USER}/:verificationCode`,
  //   element: <Pages.Verify />
  // },
  // {
  //   path: `${CONSTANTS.PAGES.MY_PRODUCTS}`,
  //   element: getElement(<Pages.MyProducts />)
  // },
  // {
  //   path: `${CONSTANTS.PAGES.MY_RENTS}`,
  //   element: getElement(<Pages.MyRents />)
  // },
  // {
  //   path: `${CONSTANTS.PAGES.PRODUCT}/:id`,
  //   element: getElement(<Pages.ProductDetail />)
  // },
  // {
  //   path: CONSTANTS.PAGES.CREATE_PRODUCT,
  //   element: getElement(<Pages.CreateProduct />)
  // },
  {
    path: CONSTANTS.PAGES.LEGAL_ADVISE,
    element: getElement(<Pages.LegalAdvice />)
  }
]);

const App = () => {

  return (
    <>
      <CssBaseline />
      <RouterProvider router={router} />
    </>
  );
}

export default App;